import { ClassValue } from 'classnames/types'
import { ReactNode } from 'react'
import { Column } from '../types/table'

interface columnVisibilityProps<T, Extra extends object> {
    allColumns: Column<T, Extra>[]
    hiddenColumns: string[]
}

export const columnVisibility = <T, Extra extends object>({
    allColumns,
    hiddenColumns = [],
}: columnVisibilityProps<T, Extra>) => {
    return allColumns.filter((item) => !hiddenColumns.includes(item.key))
}

export interface VirtualizedTableWithoutBulkActionsProps<T, Extra extends object> {
    style?: object
    load?: any
    tableHooks?: any
    filters?: any
    defaultFilter?: any
    search?: boolean
    searchPlaceholder?: any
    headerComponent?: any
    columns: Column<T, Extra>[]
    name: string
    modelName?: any
    reloadOnProfileChange?: any
    dateSelect?: boolean
    showPerPage?: boolean
    perPage?: any

    columnSelection?: any
    fetchData?: any
    selectedValues?: any
    onSelectChange?: any
    selectKey?: any
    mutableFields?: string[]
    accordion?: any
    accordionRaw?: any
    hideIfNone?: any
    className?: ClassValue
    cardClassName?: ClassValue
    canSelect?: any
    canSelectFromAllPages?: boolean
    children?: any
    setDateRangeToUrl?: any
    bulkActions?: (v: any) => ReactNode

    otherActionsLeft?: ReactNode
    otherActions?: any
    showHeader?: any
    enableRowSelect?: any
    height?: any
    rowHeight?: any

    header?: any
    minDate?: Date
    filterOverride?: any
    extra: Extra
}
